var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageReturnBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image_-_return_-_box",
    "data-name": "image - return - box",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 290.911,
    height: 292.511,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 290.911,
    height: 383.511,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 243.327,
    height: 225.592,
    transform: "translate(24.175 65.13)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M50.056,51.829V248.412l104.617,31.232,79.948-39.786V32.609Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M122.566,89.678l-.92.94h2.38V92.6h-5.879a31.536,31.536,0,0,0,.719,5.36c.06.28.14.54.221.82a22.116,22.116,0,0,0,1.979-4.82l1.9.82a23.685,23.685,0,0,1-3,6.479,7.42,7.42,0,0,0,.58,1.06c.56.86,1,1.3,1.3,1.3.2,0,.44-.96.7-2.88l1.88,1.02c-.519,2.819-1.259,4.239-2.259,4.239-.88,0-1.8-.6-2.78-1.779a8.935,8.935,0,0,1-.8-1.2,13.59,13.59,0,0,1-4.56,3.3l-1.2-1.76a13.035,13.035,0,0,0,4.8-3.659,20.285,20.285,0,0,1-.74-2.28,31.2,31.2,0,0,1-.88-6.019h-6.239v2.78h4.9q-.09,5.579-.6,6.959a2.039,2.039,0,0,1-2.1,1.28c-.479,0-1.019-.04-1.619-.1l-.64-1.9c.8.06,1.46.1,2.02.1.319-.02.539-.22.64-.62a25,25,0,0,0,.219-3.759h-2.819a16.43,16.43,0,0,1-2.46,8.958l-1.579-1.419a13.876,13.876,0,0,0,1.94-7.6V90.618h8.238c-.04-.92-.04-1.9-.04-2.9h2.12c0,1.019.019,1.979.059,2.9h2.82a14.125,14.125,0,0,0-1.92-1.76l1.32-1.26a17.009,17.009,0,0,1,2.3,2.08",
    fill: "#00d96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M126.529,91.8v-2.02h7.419V91.8h-2.66v8.379q1.44-.42,2.88-.96v2.1a62.271,62.271,0,0,1-7.339,2.059l-.54-2.119c.96-.16,1.939-.34,2.9-.541V91.8Zm12.8-3.979v3.819h4.979q0,9.988-.3,12.338-.39,2.16-3.48,2.16c-.359,0-1.019-.04-1.939-.1l-.5-1.96c.8.06,1.5.1,2.08.1,1.079,0,1.72-.42,1.879-1.22.12-.9.18-4,.22-9.278h-2.939v.12q-.12,8.639-4.64,12.658l-1.719-1.5q4.168-3.48,4.239-11.158v-.12h-2.94v-2.04h2.94V87.819Z",
    fill: "#00d96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M147.669,98.656v-9.4h1.439a9.744,9.744,0,0,0,.56-1.56l1.96.28a5.928,5.928,0,0,1-.52,1.28h2.8V93.5h-4.439v.82h4.639v4.339h-2.019v1.44h2.019v1.68h-2.019v1.74c.8-.16,1.6-.32,2.4-.5v1.74c-2.24.52-4.64.98-7.2,1.359l-.48-1.879c.32-.04.619-.061.919-.1V99.476h1.68v4.46l.92-.12v-5.16Zm4.479-7.818h-2.68v1.2h2.68Zm-2.68,6.219h2.879V95.8h-2.879Zm15.658,2.34h-1.1v4.079c0,.96-.52,1.46-1.56,1.46h-.98l-.439-1.66.779.06a.365.365,0,0,0,.42-.4V100.2h-1.44v6.039h-1.819V100.2h-1.4v4.779h-1.76V99.416h-1.1v-3.9h10.4Zm-9.359-4.72v-1.56h6.059v-.839h-7.059v-1.6h7.059v-.8h-6V88.3h7.939v2.379h1.52v1.6h-1.52v2.4Zm3.22,2.52h-2.46v1.359h2.46Zm4.339,0h-2.52v1.359h2.52Z",
    fill: "#00d96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M172.428,92.6v1.62a24.189,24.189,0,0,1-2.06,2.98h2.26v1.379a19.371,19.371,0,0,1-.92,3.5,2.568,2.568,0,0,1,.46.38,7.522,7.522,0,0,0,1.84,1.28,8.019,8.019,0,0,0,2.479.379c1.1,0,2.36.02,3.76.02,1.479,0,3.419-.059,5.819-.139l-.48,1.959h-5.079c-1.38,0-2.74-.04-4.1-.08a9.554,9.554,0,0,1-3.1-.48,6.077,6.077,0,0,1-2.28-1.539.541.541,0,0,0-.46-.22c-.36,0-.939.88-1.76,2.639l-1.5-1.4c.88-1.76,1.72-2.8,2.539-3.12a17.161,17.161,0,0,0,.82-2.819h-2.719v-1.56a32.48,32.48,0,0,0,2.219-2.9h-2.539V92.6Zm-.12-1.919-1.34,1.36a19.545,19.545,0,0,0-3.04-2.9l1.36-1.279a21.871,21.871,0,0,1,3.02,2.819M183.866,94.9v3.759h-.28l1.3.8a13.611,13.611,0,0,1-1.319,1.56c.6.4,1.16.78,1.68,1.18l-1.36,1.36a29.7,29.7,0,0,0-5.019-3.48l1.2-1.139c.719.38,1.419.78,2.059,1.179a12.484,12.484,0,0,0,1.16-1.46h-4.4a9.154,9.154,0,0,1-1.379,1.24v1.92c.92-.18,1.839-.38,2.759-.62l.34,1.6c-1.6.34-3.239.62-4.9.86l-.56-1.42c.361-.12.54-.32.54-.56v-.7a18.4,18.4,0,0,1-1.979.84l-.96-1.6a12.546,12.546,0,0,0,3.679-1.561h-1.939V94.9Zm1.42-.66h-12.2V92.6h12.2Zm-.96-2.179H174.048V88.239h10.278Zm-7.319-2.46h-1.2v1.08h1.2Zm5.019,6.759h-5.719v.86h5.719ZM179.787,89.6h-1.22v1.08h1.22Zm2.779,0h-1.22v1.08h1.22Z",
    fill: "#00d96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M201.5,53.543s-8.711-27.43-9.159-27.889c-2.211-2.269-8.563.335-14.188,5.816-5.69,5.544-8.457,11.909-6.1,14.11l.074.045L199.471,55.5a1.569,1.569,0,0,0,2.026-1.958",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M201.5,53.543s-8.711-27.43-9.159-27.889c-2.211-2.269-8.563.335-14.188,5.816-5.69,5.544-8.457,11.909-6.1,14.11l.074.045L199.471,55.5A1.569,1.569,0,0,0,201.5,53.543Z",
    fill: "none",
    stroke: "#414143",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M180.227,33.583c-4.354,4.242-7.075,8.511-6.078,9.534s5.336-1.586,9.689-5.828,7.075-8.51,6.078-9.534-5.335,1.586-9.689,5.828",
    fill: "#e48b16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M180.227,33.583c-4.354,4.242-7.075,8.511-6.078,9.534s5.336-1.586,9.689-5.828,7.075-8.51,6.078-9.534S184.581,29.341,180.227,33.583Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M167.541,40.657a.964.964,0,0,1-.339-.062,11.335,11.335,0,0,0-3.751-.466c-.221,0-.452,0-.7.009h0a.971.971,0,0,1-.994-.92l-.071-1.583a.969.969,0,0,1,.938-1.009c.286-.008.56-.012.825-.012a12.853,12.853,0,0,1,5.462.893.951.951,0,0,1,.513.625.962.962,0,0,1-.154.808l-.952,1.318a.967.967,0,0,1-.781.4",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M163.455,37.114a12.381,12.381,0,0,1,5.244.844.462.462,0,0,1,.17.69l-.952,1.317a.463.463,0,0,1-.377.191.469.469,0,0,1-.164-.029,11.736,11.736,0,0,0-3.921-.5c-.226,0-.464,0-.713.01h-.013a.468.468,0,0,1-.469-.445l-.07-1.581a.469.469,0,0,1,.453-.487q.421-.012.812-.012m0-1h0q-.4,0-.841.012a1.468,1.468,0,0,0-1.423,1.531l.07,1.581a1.464,1.464,0,0,0,1.468,1.4c.28-.008.508-.011.726-.011a10.811,10.811,0,0,1,3.576.438,1.471,1.471,0,0,0,1.7-.515l.952-1.317a1.464,1.464,0,0,0-.548-2.179,13.338,13.338,0,0,0-5.676-.941",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M171.775,17.661a.994.994,0,0,1-.98-.818l-1.11-6.1a1,1,0,0,1,.8-1.158l1.117-.2c.03-.005.15-.016.179-.016a1,1,0,0,1,.98.818l1.11,6.1a1,1,0,0,1-.8,1.159l-1.115.2c-.031,0-.149.016-.179.016",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M171.783,9.869a.5.5,0,0,1,.488.407l1.109,6.1a.5.5,0,0,1-.4.577l-1.116.2a.546.546,0,0,1-.09.007.5.5,0,0,1-.487-.407l-1.11-6.1a.5.5,0,0,1,.4-.577l1.117-.2a.448.448,0,0,1,.089-.009m0-1a1.628,1.628,0,0,0-.268.024l-1.117.2a1.5,1.5,0,0,0-1.2,1.74l1.109,6.1a1.494,1.494,0,0,0,1.471,1.227,1.446,1.446,0,0,0,.269-.024l1.116-.2a1.5,1.5,0,0,0,1.205-1.74l-1.109-6.1a1.5,1.5,0,0,0-1.472-1.229",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M180.786,20.652a1.024,1.024,0,0,1-.951-1.1l.054-4.145a1.025,1.025,0,0,1,.969-1.079l1.594.02a1.036,1.036,0,0,1,.95,1.106l-.053,4.143a1.028,1.028,0,0,1-.969,1.08Z",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M180.857,14.825h.005l1.583.021a.54.54,0,0,1,.458.6l-.054,4.144a.542.542,0,0,1-.469.586h0l-1.583-.02a.541.541,0,0,1-.458-.6l.054-4.144a.542.542,0,0,1,.468-.586m0-1a1.521,1.521,0,0,0-1.468,1.573l-.054,4.144a1.536,1.536,0,0,0,1.444,1.611l1.584.02a1.525,1.525,0,0,0,1.486-1.573l.054-4.144a1.534,1.534,0,0,0-1.445-1.61l-1.583-.021Z",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M166.96,32.875a.975.975,0,0,1-.521-.153l-3.507-2.25a.965.965,0,0,1-.29-1.335l.853-1.331a.962.962,0,0,1,1.334-.292l3.507,2.25a.967.967,0,0,1,.292,1.334l-.855,1.332a.962.962,0,0,1-.813.445",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M164.308,27.861a.464.464,0,0,1,.251.074l3.507,2.25a.465.465,0,0,1,.141.643l-.855,1.333a.465.465,0,0,1-.643.14l-3.508-2.25a.465.465,0,0,1-.14-.643l.855-1.333a.466.466,0,0,1,.392-.214m0-1a1.46,1.46,0,0,0-1.234.674l-.855,1.333a1.466,1.466,0,0,0,.443,2.025l3.507,2.25a1.465,1.465,0,0,0,2.024-.442l.855-1.333a1.466,1.466,0,0,0-.441-2.024L165.1,27.093a1.461,1.461,0,0,0-.791-.232",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M158.39,9.723a.96.96,0,0,1-.9-.6l-1.556-3.867a.95.95,0,0,1,.008-.738A.961.961,0,0,1,156.471,4l1.471-.591a.964.964,0,0,1,1.256.537l1.555,3.864a.966.966,0,0,1-.535,1.256l-1.469.592a.967.967,0,0,1-.359.069",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M158.3,3.835a.465.465,0,0,1,.432.292l1.555,3.866a.465.465,0,0,1-.258.6l-1.469.591a.459.459,0,0,1-.173.034.464.464,0,0,1-.432-.292L156.4,5.065a.465.465,0,0,1,.258-.605l1.469-.591a.464.464,0,0,1,.174-.034m0-1a1.467,1.467,0,0,0-.547.106l-1.469.591a1.466,1.466,0,0,0-.812,1.907L157.029,9.3a1.465,1.465,0,0,0,1.907.813l1.469-.591a1.467,1.467,0,0,0,.812-1.907l-1.555-3.866a1.461,1.461,0,0,0-1.36-.918",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M178.687,34.068a.967.967,0,0,1-.843-.494l-1.906-3.409a.97.97,0,0,1,.372-1.315l1.382-.772a.981.981,0,0,1,.471-.122.966.966,0,0,1,.842.493l1.908,3.409a.965.965,0,0,1-.373,1.314l-1.381.773a.974.974,0,0,1-.472.123",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M178.163,28.455a.468.468,0,0,1,.407.239l1.906,3.408a.466.466,0,0,1-.179.634l-1.382.773a.466.466,0,0,1-.633-.179l-1.907-3.409a.467.467,0,0,1,.179-.634l1.382-.773a.466.466,0,0,1,.227-.059m0-1a1.467,1.467,0,0,0-.715.187l-1.382.772a1.469,1.469,0,0,0-.564,2l1.907,3.409a1.466,1.466,0,0,0,1.994.564l1.382-.773a1.466,1.466,0,0,0,.564-1.994l-1.906-3.41a1.47,1.47,0,0,0-1.28-.75",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M187.177,30.4a20.117,20.117,0,0,1,2.384-8.7l-1.084-.638a21.043,21.043,0,0,0-2.557,9.323Z",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M170.249,25.25l.884-.893c-.447-.443-4.446-4.322-7.265-4.359l-.017,1.257c1.964.026,5.284,2.893,6.4,4",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M177.356.248,176.124,0a10.068,10.068,0,0,0,.348,8.466l1.059-.677c-1.057-1.654-1.122-6.188-.175-7.54",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M192.691,15.826a.966.966,0,0,1-.54-.166l-1.312-.888a.967.967,0,0,1-.257-1.342l1.561-2.3a.966.966,0,0,1,1.34-.26l1.312.89a.965.965,0,0,1,.257,1.341l-1.561,2.3a.964.964,0,0,1-.8.424Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M192.943,11.2a.459.459,0,0,1,.261.081l1.311.888a.467.467,0,0,1,.124.647l-1.561,2.3a.468.468,0,0,1-.386.206.459.459,0,0,1-.261-.081l-1.311-.888a.466.466,0,0,1-.124-.647l1.561-2.305a.47.47,0,0,1,.386-.2m0-1a1.465,1.465,0,0,0-1.213.643l-1.562,2.306a1.464,1.464,0,0,0,.392,2.035l1.31.888a1.463,1.463,0,0,0,2.035-.392l1.562-2.3a1.467,1.467,0,0,0-.391-2.036l-1.312-.888a1.456,1.456,0,0,0-.821-.252",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M148.321,37.087l-3.422-.242A1.073,1.073,0,0,1,143.9,35.7l.137-1.945a1.076,1.076,0,0,1,1.07-1l3.5.244a1.075,1.075,0,0,1,.995,1.147l-.136,1.945a1.08,1.08,0,0,1-1.072,1l-.074,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M145.112,33.255h.041l3.42.242a.573.573,0,0,1,.532.612l-.137,1.946a.574.574,0,0,1-.572.533l-.041,0-3.42-.241a.574.574,0,0,1-.532-.612l.137-1.946a.575.575,0,0,1,.572-.533m0-1a1.579,1.579,0,0,0-1.569,1.463l-.137,1.945a1.576,1.576,0,0,0,1.458,1.681l3.421.241c.024,0,.088,0,.111,0a1.578,1.578,0,0,0,1.569-1.463l.137-1.945a1.575,1.575,0,0,0-1.459-1.681l-3.42-.241c-.023,0-.088,0-.111,0",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M155.772,27.139,151.1,26.35a.925.925,0,0,1-.757-1.065l.278-1.644a.922.922,0,0,1,.91-.77,1.511,1.511,0,0,1,.151.013l4.677.789a.925.925,0,0,1,.756,1.065l-.278,1.644a.921.921,0,0,1-.909.77s-.127-.008-.155-.013",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M151.53,23.371a.438.438,0,0,1,.071.007l4.674.789a.422.422,0,0,1,.346.487l-.277,1.645a.422.422,0,0,1-.487.347l-4.675-.789a.422.422,0,0,1-.346-.487l.278-1.646a.423.423,0,0,1,.416-.353m0-1a1.419,1.419,0,0,0-1.4,1.186L149.85,25.2a1.424,1.424,0,0,0,1.166,1.639l4.674.79a1.374,1.374,0,0,0,.238.02,1.42,1.42,0,0,0,1.4-1.186l.278-1.646a1.424,1.424,0,0,0-1.167-1.639l-4.674-.789a1.373,1.373,0,0,0-.237-.021",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M206.563,71.446c-.242,0-.484,0-.729-.016a17.46,17.46,0,0,1,.706-34.9c.242,0,.484,0,.729.016a17.46,17.46,0,0,1-.706,34.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M206.54,37.276c.232,0,.464,0,.7.014a16.71,16.71,0,0,1-.674,33.406c-.233,0-.465,0-.7-.014a16.71,16.71,0,0,1,.675-33.406m0-1.5v0h0a18.21,18.21,0,0,0-.736,36.4c.255.01.508.015.761.015a18.21,18.21,0,0,0,.736-36.4c-.255-.011-.507-.016-.759-.016",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M199.691,52.574a1.3,1.3,0,0,0-1.348,1.242l-.04.968a1.3,1.3,0,0,0,2.59.106l.04-.968a1.3,1.3,0,0,0-1.242-1.348",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M203.235,52.719a1.3,1.3,0,0,0-1.348,1.242l-.04.969a1.3,1.3,0,0,0,2.59.1l.04-.967a1.3,1.3,0,0,0-1.242-1.349",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M223.32,50.787c-1.52-.22-4.306-.033-5.17,4.006,0,0-1.4-5.93-5.868-3.861-4.389,2.032-1.3,8.4-.45,11.454.67,2.416.3,6.219-1.638,8.172A16.62,16.62,0,0,0,223.32,50.787",
    fill: "#3ff6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M223.32,50.787c-1.52-.22-4.306-.033-5.17,4.006,0,0-1.4-5.93-5.868-3.861-4.389,2.032-1.3,8.4-.45,11.454.67,2.416.3,6.219-1.638,8.172A16.62,16.62,0,0,0,223.32,50.787Z",
    fill: "none",
    stroke: "#414143",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M192.39,54.139s3.973-2.315,1.46-6.276A4.406,4.406,0,0,0,191.4,46.09a16.637,16.637,0,0,0,.477,16.622,4.816,4.816,0,0,0,.633-.441c5.223-4.376-.123-8.132-.123-8.132",
    fill: "#3ff6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M192.39,54.139s3.973-2.315,1.46-6.276A4.406,4.406,0,0,0,191.4,46.09a16.637,16.637,0,0,0,.477,16.622,4.816,4.816,0,0,0,.633-.441C197.736,57.9,192.39,54.139,192.39,54.139Z",
    fill: "none",
    stroke: "#414143",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M199.766,38.308a2.277,2.277,0,0,1,.747,2.07,3.622,3.622,0,0,0,2.356,3.884,6.288,6.288,0,0,0,6.22-1.2s4.336,4.23,7.83-.285a2.78,2.78,0,0,0,.63-1.807,16.629,16.629,0,0,0-17.783-2.661",
    fill: "#3ff6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M199.766,38.308a2.277,2.277,0,0,1,.747,2.07,3.622,3.622,0,0,0,2.356,3.884,6.288,6.288,0,0,0,6.22-1.2s4.336,4.23,7.83-.285a2.78,2.78,0,0,0,.63-1.807,16.629,16.629,0,0,0-17.783-2.661Z",
    fill: "none",
    stroke: "#414143",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M224.773,66.5s.986,3.95-2.624,3.668c0,0-.63,4.115-4.163,2.346",
    fill: "none",
    stroke: "#414143",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M120.014,65.768c-22.3,3.265-51.98,15.017-53.875,54.246-.6,12.323-5.03,23.579-12.858,31.519-15.663,15.883-43.893,48.6-19.666,89.589,42.635,72.135,168.245,60.116,215.87-.892,38.695-49.568,8.139-93.4-26.753-108.377-13.018-5.586-24.266-16.1-31.864-29.317A75.115,75.115,0,0,0,177.42,85.577c-16.4-15.617-37.56-22.714-57.406-19.809",
    fill: "#f6ea2d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M211.148,181.846l6.5,4.728s3.877-8.2,14.256-15.075l-6.374-4.259s-9.485,5.048-14.383,14.606",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M211.148,181.846l6.5,4.728s3.877-8.2,14.256-15.075l-6.374-4.259S216.046,172.288,211.148,181.846Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    d: "M237.447,167.6l4.652,3.978a22.681,22.681,0,0,1,12.822-3.822l-2.618-4.69a19.478,19.478,0,0,0-14.856,4.534",
    fill: "#00d96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M237.447,167.6l4.652,3.978a22.681,22.681,0,0,1,12.822-3.822l-2.618-4.69A19.478,19.478,0,0,0,237.447,167.6Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    d: "M256.186,189.8s6.485,4.534,10.294-5.324c5.97-15.452,20.74-13.519,22.167-13.834l1.515-7.531s-20.81-6.259-33.434,18.648l-4.234,2.133Z",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    d: "M256.186,189.8s6.485,4.534,10.294-5.324c5.97-15.452,20.74-13.519,22.167-13.834l1.515-7.531s-20.81-6.259-33.434,18.648l-4.234,2.133Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2746",
    "data-name": "Path 2746",
    d: "M252.493,187.977c-.876-.719-1.722-5.838-.137-7.756l7.178,2.254s-2.471,5.717.812,8.1a6.949,6.949,0,0,1-7.853-2.6",
    fill: "#e48b16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M252.493,187.977c-.876-.719-1.722-5.838-.137-7.756l7.178,2.254s-2.471,5.717.812,8.1A6.949,6.949,0,0,1,252.493,187.977Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M217.974,198.694l4.543,5.2S242,176.907,259.534,182.476c0,0,1.958-8.289-11.528-7.692-11.658.517-20.451,11.889-30.032,23.91",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M217.974,198.694l4.543,5.2S242,176.907,259.534,182.476c0,0,1.958-8.289-11.528-7.692C236.348,175.3,227.555,186.673,217.974,198.694Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M233.884,206.941l5.033,8.348s10.51-11.155,37.042-11.419l-2.661-7.5s-15.853-3.928-39.414,10.569",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M233.884,206.941l5.033,8.348s10.51-11.155,37.042-11.419l-2.661-7.5S257.445,192.444,233.884,206.941Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M218.941,72.2l-92.7-26.683V118.06l92.7,26.682Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M218.941,72.2l-92.7-26.683V118.06l92.7,26.682Z",
    fill: "none",
    stroke: "#434244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M126.24,118.06l92.7,26.683L156.5,175.722,63.8,149.039Z",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M126.24,118.06l92.7,26.683L156.5,175.722,63.8,149.039Z",
    fill: "none",
    stroke: "#434244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M126.24,118.06l92.7,26.683L164.212,98.832a4.863,4.863,0,0,0-1.779-.942L73.907,72.409c-.676-.194-1.222.725-.694,1.168Z",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2757",
    "data-name": "Path 2757",
    d: "M126.24,118.06l92.7,26.683L164.212,98.832a4.863,4.863,0,0,0-1.779-.942L73.907,72.409c-.676-.194-1.222.725-.694,1.168Z",
    fill: "none",
    stroke: "#434244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2758",
    "data-name": "Path 2758",
    d: "M171.792,117.673s-2.893,2.737-2.753,10.38l-1.178,2.69-15.418,75.6.385-.225a1.782,1.782,0,0,0,.422-.233c.957-.67,2.712-1.376,3.123-3.125l15.23-70.249s4.315-9.585.189-14.841",
    fill: "#221714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2759",
    "data-name": "Path 2759",
    d: "M171.792,117.673s-2.893,2.737-2.753,10.38l-1.178,2.69-15.418,75.6.385-.225a1.782,1.782,0,0,0,.422-.233c.957-.67,2.712-1.376,3.123-3.125l15.23-70.249S175.918,122.929,171.792,117.673Z",
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M90.046,185.092,105.8,114.6l63.237,13.453-16.13,77.059a2.031,2.031,0,0,1-2.38,1.523L90.6,192.687a2.251,2.251,0,0,1-1.666-2.779Z",
    fill: "#323333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M90.046,185.092,105.8,114.6l63.237,13.453-16.13,77.059a2.031,2.031,0,0,1-2.38,1.523L90.6,192.687a2.251,2.251,0,0,1-1.666-2.779Z",
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2762",
    "data-name": "Path 2762",
    d: "M171.92,117.929l-1.913-.786-58.88-11.464c-1.731-.337-3.033.04-3.863,1.705-.138.278-.263.546-.36.786a7.912,7.912,0,0,0-.4,1.688l-.472,1.808.146.036-4.947,21.576,63.4,13.512,4.573-19.469Z",
    fill: "#323333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2763",
    "data-name": "Path 2763",
    d: "M171.92,117.929l-1.913-.786-58.88-11.464c-1.731-.337-3.033.04-3.863,1.705-.138.278-.263.546-.36.786a7.912,7.912,0,0,0-.4,1.688l-.472,1.808.146.036-4.947,21.576,63.4,13.512,4.573-19.469,2.71-9.392",
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2764",
    "data-name": "Path 2764",
    d: "M136.022,137.122a3.216,3.216,0,0,1-2.229-1.522,3.471,3.471,0,0,1-.319-2.755,4.207,4.207,0,0,1,1.778-2.375,3.934,3.934,0,0,1,2.833-.6,3.216,3.216,0,0,1,2.229,1.522,3.467,3.467,0,0,1,.319,2.755,4.2,4.2,0,0,1-1.778,2.375,4.03,4.03,0,0,1-2.084.66,3.615,3.615,0,0,1-.749-.057m-.544-6.272a3.677,3.677,0,0,0-1.554,2.076,3.041,3.041,0,0,0,.278,2.41,2.81,2.81,0,0,0,1.95,1.33,3.432,3.432,0,0,0,2.477-.527,3.679,3.679,0,0,0,1.555-2.076,3.037,3.037,0,0,0-.279-2.41,2.813,2.813,0,0,0-1.949-1.33,3.276,3.276,0,0,0-.655-.051,3.537,3.537,0,0,0-1.823.578",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2765",
    "data-name": "Path 2765",
    d: "M137.893,132.112c-.091.32-.033.6.13.634s.368-.207.459-.527.033-.6-.129-.634-.369.207-.46.527",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    "data-name": "Path 2766",
    d: "M138,132.813c-.2-.037-.279-.35-.176-.712a1.128,1.128,0,0,1,.219-.424.366.366,0,0,1,.325-.157c.1.019.178.109.208.254a1.008,1.008,0,0,1-.032.458,1.123,1.123,0,0,1-.219.423.4.4,0,0,1-.278.161.242.242,0,0,1-.047,0m.142-1.054a.958.958,0,0,0-.187.366c-.086.3-.025.535.083.555.053.011.121-.029.188-.107a.961.961,0,0,0,.187-.365.844.844,0,0,0,.029-.394c-.019-.093-.059-.152-.112-.162h-.018a.263.263,0,0,0-.17.108",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    "data-name": "Path 2767",
    d: "M136.386,131.839c-.091.32-.033.6.13.634s.368-.207.459-.527.033-.6-.129-.634-.369.207-.46.527",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    "data-name": "Path 2768",
    d: "M136.5,132.539c-.2-.037-.279-.35-.176-.712a1.128,1.128,0,0,1,.219-.424.366.366,0,0,1,.325-.157c.2.036.279.349.176.711a1.121,1.121,0,0,1-.219.424.4.4,0,0,1-.278.161.243.243,0,0,1-.047,0m.142-1.054a.958.958,0,0,0-.187.366c-.086.3-.026.535.083.555.052.01.121-.029.188-.107a.961.961,0,0,0,.187-.365c.087-.3.026-.536-.083-.556h-.018a.263.263,0,0,0-.17.108",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    "data-name": "Path 2769",
    d: "M134.928,132.3a.468.468,0,0,0,.228,0,.565.565,0,0,0,.291-.2.164.164,0,0,1,.22-.042.15.15,0,0,1,.019.215.99.99,0,0,1-.222.205,2.1,2.1,0,0,0,1.585,1.206,2.637,2.637,0,0,0,1.943-.574.1.1,0,0,1,.02-.011.706.706,0,0,1-.078-.237.173.173,0,0,1,.134-.186.138.138,0,0,1,.175.114.428.428,0,0,0,.157.276.419.419,0,0,0,.2.08.137.137,0,0,1,.119.171.175.175,0,0,1-.181.136h-.005a.7.7,0,0,1-.342-.133h0a.117.117,0,0,1-.018.021,3.033,3.033,0,0,1-2.047.668c-.051,0-.1-.009-.155-.017a2.383,2.383,0,0,1-1.808-1.389.8.8,0,0,1-.222.016,1.016,1.016,0,0,1-.121-.02.139.139,0,0,1-.093-.187.172.172,0,0,1,.2-.113",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    d: "M137.12,134.051c-.052,0-.1-.01-.157-.018a2.413,2.413,0,0,1-1.827-1.383.77.77,0,0,1-.2.01.689.689,0,0,1-.127-.021.178.178,0,0,1-.122-.24.223.223,0,0,1,.1-.123.2.2,0,0,1,.154-.023.429.429,0,0,0,.206,0,.505.505,0,0,0,.263-.178.231.231,0,0,1,.137-.084.188.188,0,0,1,.147.03.193.193,0,0,1,.025.277,1,1,0,0,1-.2.192,2.044,2.044,0,0,0,1.54,1.15,2.581,2.581,0,0,0,1.892-.554.777.777,0,0,1-.064-.214.207.207,0,0,1,.04-.15.223.223,0,0,1,.133-.09.192.192,0,0,1,.149.024.169.169,0,0,1,.077.123.388.388,0,0,0,.142.251.372.372,0,0,0,.185.071.178.178,0,0,1,.126.074.184.184,0,0,1,.027.147.228.228,0,0,1-.24.175.747.747,0,0,1-.331-.12,3.17,3.17,0,0,1-1.806.683,2.48,2.48,0,0,1-.271-.008m2.105-.77a.659.659,0,0,0,.326.126.121.121,0,0,0,.128-.1.1.1,0,0,0-.014-.081.1.1,0,0,0-.07-.04.464.464,0,0,1-.225-.088.457.457,0,0,1-.171-.3.1.1,0,0,0-.043-.068.111.111,0,0,0-.082-.013.128.128,0,0,0-.073.05.113.113,0,0,0-.022.082.727.727,0,0,0,.073.224l.02.037-.053.031a2.7,2.7,0,0,1-1.98.586,2.126,2.126,0,0,1-1.617-1.23l-.016-.035.035-.023a.88.88,0,0,0,.211-.194.1.1,0,0,0-.014-.151.1.1,0,0,0-.081-.017.129.129,0,0,0-.075.046.61.61,0,0,1-.319.214.51.51,0,0,1-.25,0,.115.115,0,0,0-.085.012.123.123,0,0,0-.057.068.1.1,0,0,0,.067.132.734.734,0,0,0,.114.019.756.756,0,0,0,.208-.015l.034-.007.013.03a2.34,2.34,0,0,0,1.778,1.366c.051.007.1.013.152.017a2.981,2.981,0,0,0,2.015-.661l.04-.045Z",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2771",
    "data-name": "Path 2771",
    d: "M162.729,138.045,142.9,134.488l.694-2.46,19.83,3.556Z",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    d: "M151.54,140.313l-9.915-1.778.7-2.461,9.915,1.778Z",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M127.933,190.249a.332.332,0,0,0-.244-.24.211.211,0,0,0-.263.115l-1.879,3.78-.991-.245,2.088-4.174a.755.755,0,0,1,.437-.418,1.255,1.255,0,0,1,.675.014,1.585,1.585,0,0,1,.658.315,1.243,1.243,0,0,1,.362.616l1.432,5.043-.984-.243Z",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M140.235,194.766l-.15,1.9a1.733,1.733,0,0,0,0,.385.615.615,0,0,0,.1.279.669.669,0,0,0,.242.2,1.734,1.734,0,0,0,.408.148l1.869.462a1.252,1.252,0,0,0,1.051-.077,1.069,1.069,0,0,0,.385-.827,1.607,1.607,0,0,0-.034-.507,1.057,1.057,0,0,0-.2-.422,1.344,1.344,0,0,0-.4-.332,2.356,2.356,0,0,0-.621-.236l-1.9-.47.024-.306a.493.493,0,0,1,.172-.364.542.542,0,0,1,.484-.044l1.62.4a.647.647,0,0,0,.833-.591l-2.4-.593a1.836,1.836,0,0,0-.643-.058.932.932,0,0,0-.457.173.879.879,0,0,0-.28.364,1.665,1.665,0,0,0-.116.511m.71,1.152,1.884.465a.768.768,0,0,1,.436.237.544.544,0,0,1,.1.381.417.417,0,0,1-.158.324.519.519,0,0,1-.441.028l-1.681-.415a.23.23,0,0,1-.2-.261Z",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    d: "M145.06,193.888a1.209,1.209,0,0,1,.38-.479,1.354,1.354,0,0,1,.613-.241,2.225,2.225,0,0,1,.855.064l2.983.737a.853.853,0,0,1-1.1.78l-2.009-.5a.671.671,0,0,0-.626.081.71.71,0,0,0-.238.506.975.975,0,0,0,.024.313.928.928,0,0,0,.121.294.892.892,0,0,0,.236.244,1.027,1.027,0,0,0,.365.163l2.095.518a.953.953,0,0,1,.84,1.159l-.1,1.3a.854.854,0,0,1-1.1.779l.168-2.132a.159.159,0,0,0-.135-.184l-1.811-.448a2.375,2.375,0,0,1-.852-.378,2.161,2.161,0,0,1-.548-.573,1.943,1.943,0,0,1-.275-.674,2.385,2.385,0,0,1-.049-.688,1.985,1.985,0,0,1,.161-.646",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    d: "M136.124,195.712l1.2.3a.84.84,0,0,0,.783-.1,1.3,1.3,0,0,0,.313-.888,1.673,1.673,0,0,0-.163-1.008,1.135,1.135,0,0,0-.738-.479l-1.213-.3a.968.968,0,0,1-.712-.921l0-.051,2.06.509a2.023,2.023,0,0,1,1.226.81,2.467,2.467,0,0,1,.345,1.64,1.874,1.874,0,0,1-.585,1.412,1.478,1.478,0,0,1-1.3.185l-2.06-.509a.654.654,0,0,1,.841-.6",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    d: "M131.314,194.031a2.191,2.191,0,0,1,.4-.422.829.829,0,0,1,.483-.158,1.491,1.491,0,0,1-.378-.378,2.95,2.95,0,0,1-.277-.518l-.6-1.444.87.214.57,1.385a2.028,2.028,0,0,0,.147.293.611.611,0,0,0,.171.183.954.954,0,0,0,.256.122c.1.033.233.069.389.107l.37.091.27-3.433a1,1,0,0,1,.738,1.011l-.329,4.177a.673.673,0,0,1-.866.614l.133-1.687-.37-.092c-.176-.043-.322-.072-.437-.089a1.041,1.041,0,0,0-.291,0,.446.446,0,0,0-.214.1,1.241,1.241,0,0,0-.194.214l-.76,1.031-.9-.222Z",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    d: "M120.138,190.207l-.183,2.331a3.024,3.024,0,0,0,.023.756,1.381,1.381,0,0,0,.216.561,1.324,1.324,0,0,0,.448.4,2.8,2.8,0,0,0,.7.263l2.375.586a.963.963,0,0,0-.71-.973l-1.514-.373a.991.991,0,0,1-.6-.345,1.058,1.058,0,0,1-.123-.671l.014-.184,1.763.436a1.523,1.523,0,0,0,1.306-.166,1.759,1.759,0,0,0,.579-1.354,2.307,2.307,0,0,0-.348-1.571,2.077,2.077,0,0,0-1.231-.788l-1.105-.273a1.23,1.23,0,0,0-1.125.155,1.669,1.669,0,0,0-.48,1.214m.812.194a.912.912,0,0,1,.259-.671.828.828,0,0,1,.706-.052l.795.2a1.159,1.159,0,0,1,.738.467,1.547,1.547,0,0,1,.169.959,1.2,1.2,0,0,1-.311.841.844.844,0,0,1-.782.094l-1.687-.417Z",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    d: "M115.084,191.319l2.445.6a1.754,1.754,0,0,0,.647.058.931.931,0,0,0,.452-.173.849.849,0,0,0,.279-.361,1.6,1.6,0,0,0,.119-.513l.109-1.38A1.851,1.851,0,0,0,119.1,189a1.275,1.275,0,0,0-.212-.485,1.443,1.443,0,0,0-.408-.387,2.136,2.136,0,0,0-.631-.257l-1.295-.319a1.275,1.275,0,0,0-1.054.071,1.072,1.072,0,0,0-.39.838,1.329,1.329,0,0,0,.242.939,1.763,1.763,0,0,0,1.02.559l1.9.469-.023.292a.507.507,0,0,1-.171.369.556.556,0,0,1-.485.04l-1.665-.411a.654.654,0,0,0-.842.6m3.236-1.523-1.876-.463a.776.776,0,0,1-.448-.243.552.552,0,0,1-.1-.386.419.419,0,0,1,.166-.332.525.525,0,0,1,.441-.033l1.287.318a.73.73,0,0,1,.46.277.677.677,0,0,1,.108.433Z",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    d: "M111.982,185.377l.226.056.1-1.243.133.033a1.261,1.261,0,0,1,.8,1.233l-.017.227,1.227.3-.011.135a.844.844,0,0,1-1.072.642l-.225-.056-.1,1.244-.133-.033a1.266,1.266,0,0,1-.8-1.232l.018-.228-1.227-.3.01-.134a.845.845,0,0,1,1.071-.644",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    d: "M126.74,193.477a.871.871,0,0,0,.643.88.587.587,0,0,0,.753-.535.872.872,0,0,0-.641-.881.587.587,0,0,0-.755.536",
    fill: "#66ba82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2782",
    "data-name": "Path 2782",
    d: "M156.5,175.722,63.8,149.039v207.04l92.7,26.682Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2783",
    "data-name": "Path 2783",
    d: "M156.5,175.722,63.8,149.039v207.04l92.7,26.682Z",
    fill: "none",
    stroke: "#434244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2784",
    "data-name": "Path 2784",
    d: "M156.5,175.722l62.445-30.979V351.782L156.5,382.761Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2785",
    "data-name": "Path 2785",
    d: "M156.5,175.722l62.445-30.979V351.782L156.5,382.761Z",
    fill: "none",
    stroke: "#434244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    d: "M144.195,343.26l-69.74-20.074V169.724l69.74,20.139Z",
    fill: "#1fd586"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2787",
    "data-name": "Path 2787",
    d: "M110.4,256.418,109,256.026l2.642-7.135a1.14,1.14,0,0,1,.586-.719,1.509,1.509,0,0,1,.961.013,2.174,2.174,0,0,1,.945.522,2.279,2.279,0,0,1,.559,1.04l2.391,8.531-1.418-.4-2.149-7.719a.522.522,0,0,0-.353-.4.284.284,0,0,0-.372.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2788",
    "data-name": "Path 2788",
    d: "M94.908,246.523a2.7,2.7,0,0,0-.345-.826,2.387,2.387,0,0,0-.618-.655,2.821,2.821,0,0,0-.907-.426l-3.431-.963a1.73,1.73,0,0,0,1.09,1.653l2.318.649a1.079,1.079,0,0,1,.672.464,1.39,1.39,0,0,1,.2.741l-.006.526-2.716-.761a2.514,2.514,0,0,0-.9-.112,1.052,1.052,0,0,0-.6.228,1.084,1.084,0,0,0-.336.534,2.78,2.78,0,0,0-.111.812,2.986,2.986,0,0,0,.433,1.678,2.414,2.414,0,0,0,1.462.976l2.673.746a1.867,1.867,0,0,0,.589.085.552.552,0,0,0,.366-.142.726.726,0,0,0,.182-.377,3.277,3.277,0,0,0,.054-.631l.032-3.26a4.017,4.017,0,0,0-.1-.939m-1.055,3.568c0,.239-.108.327-.316.269l-2.4-.671a1.01,1.01,0,0,1-.614-.4,1.175,1.175,0,0,1-.179-.663.713.713,0,0,1,.191-.548.686.686,0,0,1,.64-.039l2.695.754Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2789",
    "data-name": "Path 2789",
    d: "M88.367,242.1A3.75,3.75,0,0,0,87.9,241a3.481,3.481,0,0,0-2.032-1.483l-4.268-1.2a2.285,2.285,0,0,0,1.438,2.185l2.872.806a1.373,1.373,0,0,1,.866.642,2,2,0,0,1,.269,1.031,1.711,1.711,0,0,1-.073.5,1,1,0,0,1-.208.388.7.7,0,0,1-.36.213,1.015,1.015,0,0,1-.532-.026l-3-.84a1.026,1.026,0,0,0-1,.092,1.594,1.594,0,0,0-.321,1.149l-.022,2.239a2.276,2.276,0,0,0,1.438,2.179L83,245.206c0-.168.075-.235.214-.2l2.589.726a2.341,2.341,0,0,0,1.24.062,1.7,1.7,0,0,0,.841-.5,2.136,2.136,0,0,0,.47-.892,4.115,4.115,0,0,0,.155-1.1,4.838,4.838,0,0,0-.142-1.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M100.636,252.341l-1.722-.481a1.714,1.714,0,0,1-1.084-.8,3.46,3.46,0,0,1-.325-1.718,2.486,2.486,0,0,1,.357-1.532.986.986,0,0,1,1.093-.193l1.735.487c.586.164,1.068-.256,1.114-.944v-.086l-2.947-.827a1.739,1.739,0,0,0-1.818.345,3.432,3.432,0,0,0-.691,2.427,5.094,5.094,0,0,0,.639,2.8,3.04,3.04,0,0,0,1.8,1.358l2.947.821a1.738,1.738,0,0,0-1.1-1.662",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M107.58,253.452a6.886,6.886,0,0,0-.5-1.014,2.044,2.044,0,0,0-.656-.649,1.189,1.189,0,0,0,.577-.318,2.763,2.763,0,0,0,.452-.63l1.018-1.893-1.245-.35-.973,1.817a1.988,1.988,0,0,1-.243.365.47.47,0,0,1-.263.162.9.9,0,0,1-.373-.005c-.148-.029-.335-.075-.557-.137l-.53-.149.057-5.872c-.633-.178-1.152.3-1.159,1.068l-.07,7.147a1.784,1.784,0,0,0,1.132,1.709l.029-2.886.53.148a5.994,5.994,0,0,1,.621.206,1.789,1.789,0,0,1,.408.234,1.178,1.178,0,0,1,.288.33,4.038,4.038,0,0,1,.244.509l.933,2.31,1.287.358Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2792",
    "data-name": "Path 2792",
    d: "M123.186,253.8a2.553,2.553,0,0,0-1.558-1.162l-1.579-.443a1.807,1.807,0,0,0-1.822.3,3.129,3.129,0,0,0-.689,2.3,4.772,4.772,0,0,0,.639,2.685,3.1,3.1,0,0,0,1.806,1.322l2.523.7,0,.313a1.488,1.488,0,0,1-.258,1c-.169.172-.466.2-.89.079l-2.166-.6c-.611-.17-1.109.29-1.116,1.025l3.4.944a2.972,2.972,0,0,0,1.012.131,1.061,1.061,0,0,0,.678-.289,1.566,1.566,0,0,0,.375-.745,5.472,5.472,0,0,0,.127-1.22l.04-3.964a4.49,4.49,0,0,0-.515-2.373m-.668,4.449-2.413-.673a1.715,1.715,0,0,1-1.083-.782,3.161,3.161,0,0,1-.327-1.629,2.213,2.213,0,0,1,.357-1.436,1.017,1.017,0,0,1,1.093-.172l1.135.319a1.613,1.613,0,0,1,.982.653,2.432,2.432,0,0,1,.279,1.309Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2793",
    "data-name": "Path 2793",
    d: "M129.528,260.4l-2.381-.664a1.094,1.094,0,0,1-.673-.454,1.381,1.381,0,0,1-.193-.741l.005-.5L129,258.8a1.61,1.61,0,0,0,1.5-.094,1.727,1.727,0,0,0,.457-1.34,2.936,2.936,0,0,0-.439-1.684,2.472,2.472,0,0,0-1.466-.964l-1.851-.52a2.142,2.142,0,0,0-.916-.087,1.121,1.121,0,0,0-.621.3,1.346,1.346,0,0,0-.358.622,3.138,3.138,0,0,0-.119.87l-.023,2.346a3.847,3.847,0,0,0,.1.937,2.543,2.543,0,0,0,.344.813,2.408,2.408,0,0,0,.611.648,2.775,2.775,0,0,0,.913.424l3.5.974a1.728,1.728,0,0,0-1.1-1.652m-3.224-4.165a.894.894,0,0,1,.206-.622c.136-.144.361-.172.679-.083l1.841.516a1.02,1.02,0,0,1,.613.407,1.172,1.172,0,0,1,.19.678.708.708,0,0,1-.195.546c-.129.112-.348.123-.658.037l-2.683-.751Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2794",
    "data-name": "Path 2794",
    d: "M135.725,254.842l-.324-.091.021-2.106-.189-.053c-.712-.09-1.266.483-1.275,1.369l0,.384-1.756-.493,0,.229a2.214,2.214,0,0,0,1.418,1.911l.323.09-.021,2.109.19.054c.708.085,1.264-.489,1.273-1.37l0-.387,1.755.492,0-.227a2.216,2.216,0,0,0-1.416-1.911",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2795",
    "data-name": "Path 2795",
    d: "M114.05,256.224c-.007.665-.459,1.082-1.012.928a1.555,1.555,0,0,1-.985-1.485c.006-.667.46-1.085,1.009-.931a1.555,1.555,0,0,1,.988,1.488",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2796",
    "data-name": "Path 2796",
    d: "M103.924,208.989l13.9-6.247-20.8-14.992-15.17,4.672Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2797",
    "data-name": "Path 2797",
    d: "M94.295,217.888l.327-8.55,8.533,6.371.152-5.447L80.824,193.391l-.433,18.369,22.381,17.728.141-5.068Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2798",
    "data-name": "Path 2798",
    d: "M112.867,213.76a1.794,1.794,0,0,1,1.252-1.923l4.19-.912.319-6.663-13.987,6.29-.529,19.012,8.791-4.293Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2799",
    "data-name": "Path 2799",
    d: "M114.144,217.02a.609.609,0,0,1-.308-.221l.075,23.784a1.768,1.768,0,0,0,.465,1.18,1.057,1.057,0,0,0,.982.392l22.211-4.7a.934.934,0,0,0,.665-1l-.018-5.513-8.71,1.6-.032-10.094,8.71-1.61-.027-8.475-23.838,4.665a.386.386,0,0,1-.175-.008",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2800",
    "data-name": "Path 2800",
    d: "M138.275,210.088c0-.033,0-.065,0-.1,0-.014,0-.027,0-.041-.005-.044-.011-.088-.02-.132l0-.016c-.009-.039-.019-.078-.03-.116a.411.411,0,0,0-.015-.046c-.009-.03-.02-.059-.031-.088l-.018-.045c-.018-.041-.036-.081-.057-.121a1.619,1.619,0,0,0-.177-.266,1,1,0,0,0-.943-.428l-22.081,4.532a3.888,3.888,0,0,1,.294,2.383l22.727-4.438a1.551,1.551,0,0,0,.239-.432l.006-.018c.012-.034.024-.069.035-.107,0-.014.008-.029.013-.044.008-.033.017-.066.024-.1,0-.016.007-.031.01-.047.011-.051.02-.1.027-.159s.007-.088.008-.132v-.04",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2801",
    "data-name": "Path 2801",
    d: "M184.178,152.465a2.821,2.821,0,0,1-.76-.106,2.608,2.608,0,0,1-.784-.368,2.746,2.746,0,0,1-.335-.26l-4.916-4.7a2.922,2.922,0,0,1,.066-4.117,3.139,3.139,0,0,1,2.248-.983,2.689,2.689,0,0,1,1.787.661v-8.738a3.219,3.219,0,0,1,2.829-3.127,2.859,2.859,0,0,1,.3-.016,2.662,2.662,0,0,1,2.688,2.693v8.475a3.124,3.124,0,0,1,2.239-.972,2.634,2.634,0,0,1,2.668,2.454,3.117,3.117,0,0,1-.756,2.264l-4.92,5.73a2.71,2.71,0,0,1-.233.234l-.073.068a3.255,3.255,0,0,1-.7.482l-.1.044a3,3,0,0,1-.887.262l-.143.013c-.075.007-.149.01-.224.01",
    fill: "#f6ea2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M184.617,131.458a1.9,1.9,0,0,1,1.938,1.943v10.492l1.192-1.39a2.4,2.4,0,0,1,1.8-.848,1.935,1.935,0,0,1,1.251.44h0a2.141,2.141,0,0,1,.091,3.039l-4.919,5.729a1.838,1.838,0,0,1-.172.17l-.067.063a2.52,2.52,0,0,1-.538.37l-.056.025a2.321,2.321,0,0,1-.687.206l-.012,0-.038,0-.057.005c-.054,0-.108.007-.161.007a2.113,2.113,0,0,1-.56-.078,1.9,1.9,0,0,1-.563-.264l-.067-.049a1.38,1.38,0,0,1-.171-.134l-4.917-4.7a2.174,2.174,0,0,1,.089-3.058,2.381,2.381,0,0,1,1.705-.751,1.926,1.926,0,0,1,1.344.523l1.193,1.142V133.851a2.455,2.455,0,0,1,2.156-2.381,2.207,2.207,0,0,1,.228-.012m0-1.5a3.825,3.825,0,0,0-.383.02,3.938,3.938,0,0,0-3.5,3.873v7.481a3.541,3.541,0,0,0-1.037-.154,3.89,3.89,0,0,0-2.788,1.214,3.671,3.671,0,0,0-.044,5.178l4.918,4.7a3.011,3.011,0,0,0,.35.281l.044.032a3.461,3.461,0,0,0,1.034.492,3.581,3.581,0,0,0,.97.136c.094,0,.188,0,.283-.012l.069-.006h.01l.041,0,.062-.006.037-.007a3.827,3.827,0,0,0,1.09-.331l.024-.009.035-.016.035-.017a4,4,0,0,0,.862-.591l.092-.085a3.222,3.222,0,0,0,.288-.293l4.917-5.726a3.874,3.874,0,0,0,.935-2.816,3.4,3.4,0,0,0-1.2-2.349,3.45,3.45,0,0,0-2.215-.792,3.764,3.764,0,0,0-1.49.308V133.4a3.4,3.4,0,0,0-3.437-3.443Z",
    fill: "#434244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M70.458,145.756c-.025,0-.109-.006-.134-.073l-3.868-11.145a.233.233,0,0,1,.028-.189.367.367,0,0,1,.209-.177l1.176-.376c4.738-1.505,11.892-3.777,17.939-10.213,6.562-6.985,10.4-8.9,17.844-8.9.578,0,1.178.012,1.819.037l-.9,4.682a5.664,5.664,0,0,0-.218,4.589,2.052,2.052,0,0,0,1.984,1.26l14.333,1a1.235,1.235,0,0,1,1.252,1.156,1.665,1.665,0,0,1-.994,1.719c-3.324,1.651-8.1,2.045-11.931,2.36l-.3.026c-4.839.4-8.545,1.027-12.145,5.474-2.739,3.386-6.1,6.764-14.287,7.63a7.994,7.994,0,0,1-.834.033c-.617,0-1.369-.032-2.151-.065-.977-.041-1.933-.082-2.829-.082a11,11,0,0,0-3.421.393l-2.476.842Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2804",
    "data-name": "Path 2804",
    d: "M103.654,115.435h0c.3,0,.6,0,.912.01l-.721,3.737a6.436,6.436,0,0,0-.194,5.092A2.816,2.816,0,0,0,106.273,126l14.363,1a.484.484,0,0,1,.536.492.92.92,0,0,1-.583.962c-3.2,1.588-7.891,1.974-11.665,2.284l-.3.025c-5.027.416-8.878,1.072-12.666,5.751-2.75,3.4-5.873,6.519-13.783,7.356-.177.019-.432.028-.759.028-.6,0-1.355-.032-2.149-.066-.938-.039-1.908-.08-2.826-.08a11.511,11.511,0,0,0-3.663.432l-1.952.664-3.505-10.1.718-.228.053-.017c4.809-1.527,12.076-3.834,18.258-10.414,6.388-6.8,10.107-8.662,17.3-8.662m0-1.5c-7.848,0-11.909,2.234-18.392,9.135-5.915,6.3-12.959,8.532-17.619,10.011-.415.132-.81.257-1.182.378a1.113,1.113,0,0,0-.635.532.977.977,0,0,0-.078.794l3.869,11.144a.873.873,0,0,0,.841.577,1.022,1.022,0,0,0,.331-.056l2.476-.842a10.618,10.618,0,0,1,3.181-.352c.885,0,1.83.04,2.762.079.8.034,1.578.067,2.213.067a8.888,8.888,0,0,0,.917-.037c8.473-.9,11.953-4.4,14.791-7.9,3.421-4.225,6.824-4.8,11.624-5.2l.3-.025c3.9-.32,8.754-.72,12.207-2.436a2.421,2.421,0,0,0,1.406-2.478,1.968,1.968,0,0,0-1.946-1.816l-14.377-1a1.3,1.3,0,0,1-1.3-.791,4.911,4.911,0,0,1,.243-4.082l1.085-5.619c-.957-.05-1.86-.077-2.718-.077",
    fill: "#404143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M56.152,159.139S54.1,149.324,43.19,143.708l-4.044,3.922s11.176,6.232,12.8,13.883Z",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2807",
    "data-name": "Path 2807",
    d: "M56.152,159.139S54.1,149.324,43.19,143.708l-4.044,3.922s11.176,6.232,12.8,13.883Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2808",
    "data-name": "Path 2808",
    d: "M15.137,147.375s-.868-5.04,6.471-10.22l3.462,3.8s-8.745,5.358-2.19,10.125c0,0-5.435,4.029-7.743-3.706",
    fill: "#00d96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2809",
    "data-name": "Path 2809",
    d: "M15.137,147.375s-.868-5.04,6.471-10.22l3.462,3.8s-8.745,5.358-2.19,10.125C22.88,151.081,17.445,155.11,15.137,147.375Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2810",
    "data-name": "Path 2810",
    d: "M22.88,151.08c-5.7,1.635-7.743-3.706-7.743-3.706.34,12.782,12.228,8.536,12.228,8.536s9.839-2.139,18.214,14.032l3.935-4.126S41.875,145.632,22.88,151.08",
    fill: "#0ff497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2811",
    "data-name": "Path 2811",
    d: "M22.88,151.08c-5.7,1.635-7.743-3.706-7.743-3.706.34,12.782,12.228,8.536,12.228,8.536s9.839-2.139,18.214,14.032l3.935-4.126S41.875,145.632,22.88,151.08Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2812",
    "data-name": "Path 2812",
    d: "M50.279,186.2s-8.114-21.919-30.949-22.7l-.356,4.9s19.029,2.768,23.935,20.8Z",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2813",
    "data-name": "Path 2813",
    d: "M50.279,186.2s-8.114-21.919-30.949-22.7l-.356,4.9s19.029,2.768,23.935,20.8Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2814",
    "data-name": "Path 2814",
    d: "M13.721,161.774s-6.775-1.893-9.45-6.79L.75,159.109s6.078,8.5,12.414,6.976Z",
    fill: "#ffab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2815",
    "data-name": "Path 2815",
    d: "M13.721,161.774s-6.775-1.893-9.45-6.79L.75,159.109s6.078,8.5,12.414,6.976Z",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 300,
    height: 300,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageReturnBox);
export default __webpack_public_path__ + "static/media/image-return-box.032c105f85fec893aa3f40e72ce0c2c7.svg";
export { ForwardRef as ReactComponent };